// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-user-dialog.common-dialog[data-v-ebc14c36] .el-dialog{width:var(--common-dialog-width)}.edit-user-dialog.common-dialog .el-form[data-v-ebc14c36]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
